<template>
  <fc-designer ref="designer" height="100vh" />

</template>
<script setup>
  import { ref } from 'vue';
  // 可以在此处获取设计器实例或进行其他操作
  const designer = ref(null);
</script>